import React from 'react';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import BlockButton from './BlockButton';

function UnorderedListButton() {
  return <BlockButton format="unorderedList" Icon={<FormatListBulletedIcon fontSize="small" />} />;
}

export default UnorderedListButton;
